import { render, staticRenderFns } from "./employees.view.vue?vue&type=template&id=062230f5&scoped=true&"
import script from "./employees.view.vue?vue&type=script&lang=ts&"
export * from "./employees.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062230f5",
  null
  
)

export default component.exports